module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingResult/images/landing-result-award_small.RU.1a8fc158.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingResult/images/landing-result-award_small.RU.png
// module id = 3142
// module chunks = 11